<div class="card-novo-sm mr-2">
  <div (click)="handleClick()" class="block no-underline cursor-pointer">
    <div class="flex flex-col p-0 h-[200px]">
      <div  [ngClass]="bgColor" class="flex-grow flex text-center items-center rounded-t-3xl justify-center h-8/10 w-5/5 overflow-visible">
        <mat-icon [ngClass]="textColor" class="material-symbols-outlined w-full h-full object-cover rounded-t-[22px] icon-in-card" >{{icon}}</mat-icon>
      </div>
      <div class="flex items-center object-cover footer-card rounded-b-3xl justify-center h-2/10 pt-3">
        <h4 > {{ title }} </h4>
      </div>
    </div>
  </div>
</div>
